import { useNativeLoaderHandler } from '../../hooks'

function PageLoader() {
	return useNativeLoaderHandler()
}
export default PageLoader
